export class CardBaseComponent {
    public classList =

        'relative flex flex-col h-full min-w-0';
}
